export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    activeTab: {
      type: String,
      default: null,
    },
  },
  created() {
    if (this.activeTab) {
      this.onChange(this.activeTab, true);
    } else if (this.items.length > 0) {
      this.onChange(this.items[0].name);
    }
  },
  data() {
    return {
      currentTab: this.activeTab,
    };
  },
  watch: {
    activeTab(tab) {
      if (tab !== this.currentTab) {
        this.onChange(tab);
      }
    },
  },
  methods: {
    tabLinkModifiers(item) {
      return {
        tabs__link: true,
        [`tabs__link-name-${item.name}`]: true,
        'tabs__link--with-icon': item.icon,
        [`tabs__link--${this.theme}-${item.name}`]: true,
        'tabs__link--stats': item.kind && item.kind === 'stats',
        'tabs__link--active': item.name === this.currentTab,
      };
    },
    tabItemModifiers(item) {
      return {
        tabs__item: true,
        'tabs__item--stats': item.kind && item.kind === 'stats',
      };
    },
    tabIconModifiers(item) {
      return {
        tabs__icon: true,
        [`tabs__icon--${item.icon}`]: item.icon,
      };
    },
    onChange(name, startedWithActiveTab = false) {
      if (name !== this.currentTab) {
        this.currentTab = name;
        this.$emit('tabChange', name);
      } else if (startedWithActiveTab) {
        this.$emit('tabChange', this.currentTab);
      }
    },
  },
};
